const TileType = {
  BOMB: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
};

export default TileType;
